import { IGeoUndergroundInfo } from '../../types/geo';
import { IApplicationState } from '../../types/redux';

export function getUndergroundInfo(state: IApplicationState): IGeoUndergroundInfo[] | null {
  const {
    newbuilding: { geo },
  } = state;

  if (geo && geo.undergroundInfo && geo.undergroundInfo.length) {
    return geo.undergroundInfo;
  }

  return null;
}
